<script setup lang="ts">
  import type { ServicesSectionContent } from '@/models/service';
  import type { PropType } from 'vue';
  import ServiceCard from './ServiceCard.vue';
  import CustomServiceCard from './CustomServiceCard.vue';

  defineProps({
    servicesSectionContent: {
      type: Object as PropType<ServicesSectionContent>,
      required: true
    },
    localePath: {
      type: Function as PropType<(to: { name: string; params: { slug: string } }) => string>,
      required: true
    }
  });

  const emits = defineEmits(['contactClick']);

  const onContactClick = () => {
    emits('contactClick');
  };
</script>

<template>
  <div
    v-if="servicesSectionContent.useCases.length"
    class="services-section__grid">
    <ServiceCard
      v-for="(useCaseItem, index) in servicesSectionContent.useCases"
      :key="index"
      :use-case-item="useCaseItem"
      :use-case-button-text="servicesSectionContent.useCaseButtonText"
      :locale-path="localePath" />
    <CustomServiceCard
      :service-section-content="servicesSectionContent"
      @contact-click="onContactClick" />
  </div>
</template>
